export function setCookie(name, value, hours = 1, path = '/') {
  const expires = new Date(Date.now() + hours * 60 * 60 * 1000)
    .toUTCString();
  const encodedValue = encodeURIComponent(value);

  document.cookie = `${name}=${encodedValue}; expires=${expires}; path=${path}`;
}

export function getCookie(name) {
  const match = window.document.cookie.match(
    new RegExp(`(^|;)\\s*${name}\\s*=\\s*([^;]*)\\s*(;|$)`),
  );
  return match ? decodeURIComponent(match[2]) : null;
}
